import { render } from "./OrderYoungAdults.vue?vue&type=template&id=1887e4c6&scoped=true&ts=true"
import script from "./OrderYoungAdults.vue?vue&type=script&lang=ts"
export * from "./OrderYoungAdults.vue?vue&type=script&lang=ts"

import "./OrderYoungAdults.vue?vue&type=style&index=0&id=1887e4c6&lang=css"
import "./OrderYoungAdults.vue?vue&type=style&index=1&id=1887e4c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1887e4c6"]])

export default __exports__